import { p as o } from "./promise-native-constructor.js";
import { c as t } from "./check-correctness-of-iteration.js";
import { p as r } from "./promise-constructor-detection.js";
var c = r.CONSTRUCTOR || !t(function (t) {
  o.all(t).then(void 0, function () {});
});
export { c as p };